import { render, staticRenderFns } from "./ViewYinhuashuiTable.vue?vue&type=template&id=4c5b5b52&scoped=true&"
import script from "./ViewYinhuashuiTable.vue?vue&type=script&lang=js&"
export * from "./ViewYinhuashuiTable.vue?vue&type=script&lang=js&"
import style0 from "./ViewYinhuashuiTable.vue?vue&type=style&index=0&id=4c5b5b52&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b5b52",
  null
  
)

export default component.exports